:host {
  --justify-content: inherit;
  --padding-left: calc(#{$formInputHeight} + #{space('medium')});
}

.stzh-pagination {
  position: relative;
  display: flex;
  align-items: center;
  gap: space('medium');
  padding-left: var(--padding-left);
  justify-content: var(--justify-content);

  &__input {
    --text-align: center;
    --input-width: #{$formInputHeight};
    --padding-top: 0px;
    --padding-bottom: 0px;
    --padding-left: 0px;
    --padding-right: 0px;

    position: absolute;
    top: 0;
    left: 0;
  }

  &__total {
    @include fontSize('nano');
    color: $colorGrey70;
  }

  &--size-small {
    padding-left: calc(#{$formInputHeightSmall} + #{space('medium')});
  }

  &--size-small &__input {
    --input-width: #{$formInputHeightSmall};
  }
}
